import reducer from "./reducer";

import * as alertSelectors from "./selectors";
import * as alertOperations from "./operations";
import * as alertTypes from "./types";

export { alertSelectors, alertOperations, alertTypes };

export default reducer;
